<template>
  <div>
    <wc-section-title title='Inquiries'></wc-section-title>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'inquiries-base',
  computed: {
    menu () {
      return [
        {
          title: 'Inquiries Dashboard',
          icon: this.$store.state.icons.modules.inquiries.icon,
          route: { name: 'InquiriesDashboard' }
        },
        {
          title: 'Progressed & Archived',
          icon: this.$store.state.icons.archive.icon,
          route: { name: 'SoldAndArchivedInquiries' }
        }
      ]
    }
  },
  mounted () {
    this.$store.dispatch('loadMainMenuTitle', 'Inquiries Menu')
    this.$store.dispatch('loadMainMenu', this.menu)
  }
}
</script>
